import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { React, useState } from 'react';
import Colors from '../../colors';
import { NOTES } from '../../constants';
import MultilineInput from '../MultilineInput';
import PhoneTextInput from '../PhoneTextInput';
import TextInput from '../TextInput';
import OutlineButton from './Buttons/outline/OutlinedModalButton';
import ConfirmationModal from './ConfirmationModal';
import ModalContainer from './ModalContainer';
import ModalTitle from './Text/ModalTitle';

const style = {
    width: '100%',
    p: 1,
};

const ButtonContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    alignContent: 'center',
});

function EditMemberModal({
    isVisible,
    setIsVisible,
    firstNameValue,
    setFirstNameText,
    lastNameValue,
    setLastNameText,
    setPhoneNumText,
    phoneNumberValue,
    setNotesText,
    notesValue,
    onClickSave,
    onClickDelete,
    firstName,
    lastName,
}) {
    const [deleteConfirmationModalIsVisible, setDeleteConfirmationModalIsVisible] = useState(false);
    const [errMsg, setErrMsg] = useState();
    const handleClose = () => setErrMsg();

    const handleMissingRequirements = () => {
        if (firstName.length === 0 || lastName.length === 0) {
            setErrMsg('Please give the member a full name.');
            return;
        }
    };

    const errMsgStyles = {
        color: 'red',
        marginTop: '-12px'
    };

    return (
        <ModalContainer
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            onClose={handleClose}>
            <Box sx={style}>
                <ModalTitle
                    label={'Edit Member'} />
                <TextInput
                    label={'First Name'}
                    setText={setFirstNameText}
                    value={firstNameValue} />
                <TextInput
                    label={'Last Name'}
                    setText={setLastNameText}
                    value={lastNameValue} />
                <PhoneTextInput
                    label={'Phone Number (Optional)'}
                    phoneNumberText={phoneNumberValue}
                    setPhoneNumberText={setPhoneNumText} />
                <MultilineInput
                    label={'Notes (optional)'}
                    placeholder={NOTES}
                    maxChars={250}
                    setText={setNotesText}
                    value={notesValue} />
            </Box>

            {errMsg && <span style={errMsgStyles}>{errMsg}</span>}

            <ButtonContainer>
                {firstName.length === 0 || lastName.length === 0
                    ? <OutlineButton
                        color={Colors.mediumGray}
                        label={'Save Changes'}
                        onClick={handleMissingRequirements}>
                    </OutlineButton>
                    :
                    <OutlineButton
                        color={Colors.blue}
                        label={'Save Changes'}
                        onClick={onClickSave} />
                }
                <OutlineButton
                    color={Colors.red}
                    label={'Delete'}
                    onClick={() => setDeleteConfirmationModalIsVisible(true)} />
            </ButtonContainer>
            <ConfirmationModal
                isVisible={deleteConfirmationModalIsVisible}
                setIsVisible={setDeleteConfirmationModalIsVisible}
                mainAction={'Delete'}
                mainActionHandler={onClickDelete}
                title={'Are you sure you want to delete this member?'} />

        </ModalContainer>
    );
}

export default EditMemberModal;